/** @format */

import { authActions } from './actions';
import { reducerDebug } from '../../core/debug';

const token = window.sessionStorage.getItem('token');
const passwordModalState = { passwordModalOpen: false };
const certificationModalState = { passwordModalOpen: false };
const initialState = token
    ? { validToken: true, ...passwordModalState, ...certificationModalState }
    : { validToken: false, ...passwordModalState, ...certificationModalState };

export type AuthReducersType = {
    type?: string;
    validToken: boolean;
    loginError: boolean;
    loginErrorMessage: string | null;
    passwordModalOpen?: boolean;
    certificationModalOpen?: boolean;
    disableModalClose?: boolean;
    modalModifiedSubTitle?: string;
};

export function auth(state = initialState, action: AuthReducersType): object {
    reducerDebug('Auth reducer: ' + action.type);
    switch (action.type) {
        case authActions.LOGIN:
        case authActions.LOGOUT:
            return {
                ...state,
                validToken: false,
                loginError: false,
                loginErrorMessage: null,
            };
        case authActions.LOGERROR:
            return {
                ...state,
                loginError: true,
                loginErrorMessage: action.loginErrorMessage ? action.loginErrorMessage : null,
            };
        case authActions.TOGGLE_MODAL:
            return {
                ...state,
                ...action,
            };
        default:
            return {
                ...state,
                type: action.type,
                loginError: false,
                loginErrorMessage: null,
            };
    }
}
